import type { BlogPostMeta } from "@/types/blog";

export const STAFF_NOTIFICATION_EMAIL = process.env.STAFF_NOTIFICATION_EMAIL || 'parts@miller40.com';

export const NEWSLETTER_FROM_EMAIL = process.env.NEWSLETTER_FROM_EMAIL || 'info@miller40.com';
export const NEWSLETTER_FROM_NAME = process.env.NEWSLETTER_FROM_NAME || 'Miller40';

// Sender of the booking request emails (WSP-852): the alert to the shop and the
// receipt to the customer. Same verified domain as the other transactional mail.
export const BOOKING_FROM_EMAIL = process.env.BOOKING_FROM_EMAIL || 'info@miller40.com';
export const BOOKING_FROM_NAME = process.env.BOOKING_FROM_NAME || 'Miller40';

// Where the shop alert for a new booking request goes (WSP-852). The alert IS the
// workflow, so there is always a real mailbox: with the env var unset the alert
// still reaches a person instead of being dropped while the customer is told the
// request was received. Same pattern as STAFF_NOTIFICATION_EMAIL above.
export const BOOKING_FORM_RECIPIENT = process.env.BOOKING_FORM_RECIPIENT || 'info@miller40.com';

// Shipping tracking field constraints
export const TRACKING_NUMBER_MAX_LENGTH = 100;
export const TRACKING_URL_MAX_LENGTH = 500;

export const locationIframeMap = {
  "miami":
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7188.228227863507!2d-80.30706818906808!3d25.733739609665612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9b86c2040bdfb%3A0xc837587bc5637ec5!2s6795%20SW%2040th%20St%2C%20Miami%2C%20FL%2033155%2C%20USA!5e0!3m2!1sen!2sde!4v1749402949171!5m2!1sen!2sde",
  "collision-center":
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3594.5!2d-80.31408!3d25.73133!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9b865!2s7350%20SW%2042nd%20St%2C%20Miami%2C%20FL%2033155%2C%20USA!5e0!3m2!1sen!2sus!4v1712600000000!5m2!1sen!2sus",
  "calle-8":
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7186.469524835793!2d-80.30617578906717!3d25.762808208464996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9b84b6bd6945b%3A0x4a090eb4ef6c5be3!2s6698%20SW%208th%20St%2C%20Miami%2C%20FL%2033144%2C%20USA!5e0!3m2!1sen!2sde!4v1749403197935!5m2!1sen!2sde",
};

/**
 * Locale-independent blog post metadata (images, slugs, authors, dates, tags).
 * Translatable copy (title, excerpt, categories) lives in
 * i18n/messages/{locale}/layout.json under "blogPosts", keyed by `id` —
 * translated markdown bodies live in i18n/messages/{locale}/blog-content.json,
 * also keyed by `id`. See lib/blog.ts's getBlogPost() for the join, which is
 * done by id rather than array position on purpose (see PR review).
 */
export const BLOG_POST_META: BlogPostMeta[] = [
  {
    id: "1",
    slug: "essential-car-maintenance-tips-miami",
    categorySlug: "maintenance",
    author: { name: "Edgar Paniagua" },
    publishedAt: "2025-06-10",
    image: "/images/blog/explain-maintenance.jpg",
    tags: ["maintenance", "tips", "miami"],
  },
  {
    id: "2",
    slug: "understanding-car-warning-lights",
    categorySlug: "tips",
    author: { name: "Miller40 Team" },
    publishedAt: "2025-06-08",
    image: "/images/blog/light-maintenance.jpg",
    tags: ["warning-lights", "dashboard", "safety"],
  },
  {
    id: "3",
    slug: "future-electric-vehicle-maintenance",
    categorySlug: "tips",
    author: { name: "Miller40 Team" },
    publishedAt: "2025-05-28",
    image: "/images/blog/electric-vehicle.jpg",
    tags: ["electric-vehicles", "future", "maintenance"],
  },
  {
    id: "4",
    slug: "regular-oil-changes-save-money",
    categorySlug: "maintenance",
    author: { name: "Miller40 Team" },
    publishedAt: "2025-05-20",
    image: "/images/blog/oil-maintenance.jpg",
    imagePosition: "center 70%",
    tags: ["oil-change", "cost-savings", "engine"],
  },
  {
    id: "5",
    slug: "signs-brakes-need-attention",
    categorySlug: "repairs",
    author: { name: "Miller40 Team" },
    publishedAt: "2025-05-15",
    image: "/images/blog/brake-maintenance.jpg",
    tags: ["brakes", "safety", "warning-signs"],
  },
  {
    id: "6",
    slug: "customer-success-maria-honda-civic",
    categorySlug: "customer-stories",
    author: { name: "Miller40 Team" },
    publishedAt: "2025-05-10",
    image: "/images/blog/6.png",
    tags: ["customer-story", "honda", "restoration"],
  },
];
